import { Component, inject } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from "@angular/router";
import {
  AmplifyAuthenticatorModule,
  AuthenticatorService,
} from "@aws-amplify/ui-angular";
import { TranslateService } from "@ngx-translate/core";
import { Amplify } from "aws-amplify";
import { environment } from "src/environments/environment";

import { CoreService } from "./services/core.service";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { LoaderService } from "./shared/components/loader/loader.service";
import { NetworkStatusComponent } from "./shared/components/network-status/network-status.component";
import { TranslationLoaderService } from "./shared/services/translation-loader.service";
import { AppInitialDataService } from "./shared/services/app-initial-data.service";
import { SessionService } from "./services/session.service";
import { MatDialog } from "@angular/material/dialog";
import { UsageOverviewMinimizedComponent } from "./pages/billing/billing-status-widget/usage-overview-minimized/usage-overview-minimized.component";

@Component({
  selector: "app-root",
  imports: [
    RouterOutlet,
    AmplifyAuthenticatorModule,
    LoaderComponent,
    NetworkStatusComponent,
    UsageOverviewMinimizedComponent,
  ],
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title = "Treeslo";
  router = inject(Router);
  translate = inject(TranslateService);
  settings = inject(CoreService);
  private loaderSvc = inject(LoaderService);
  private appInitialDataService = inject(AppInitialDataService);
  private translationLoader = inject(TranslationLoaderService);
  matDialog = inject(MatDialog);

  constructor(public authenticator: AuthenticatorService) {
    inject(SessionService).trackOAuthRedirect(
      environment.cognitoUserPoolClientId,
    );
    Amplify.configure({
      API: {
        REST: {
          ["gateway-api"]: {
            endpoint: environment.baseApiUrl,
            region: environment.awsRegion,
          },
        },
      },
      Auth: {
        Cognito: {
          userPoolId: environment.cognitoUserPoolId,
          userPoolClientId: environment.cognitoUserPoolClientId,
          signUpVerificationMethod: "code",
          loginWith: {
            email: true,
            oauth: {
              domain: environment.oAuthDomain,
              scopes: ["phone", "email", "profile", "openid"],
              redirectSignIn: [environment.baseAppUrl],
              redirectSignOut: [environment.baseAppUrl],
              responseType: "code", // Using Authorization Code Grant Flow
              providers: ["Amazon"],
            },
          },
        },
      },
    });
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderSvc.show();

        if (
          event.url?.startsWith("/auth/login") ||
          event.url?.startsWith("auth/login")
        ) {
          this.appInitialDataService.cleanCaches();
        }
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationError ||
        event instanceof NavigationCancel
      ) {
        this.loaderSvc.hide();
      }
    });

    const returnUrl = localStorage.getItem("redirectUrl");
    if (returnUrl) {
      localStorage.removeItem("redirectUrl");
      setTimeout(() => {
        this.router.navigateByUrl(returnUrl);
      }, 0);
    }
  }
}
